import HorizontalMenu, { MenuProp } from "@/components/navigation/HorizontalMenu";
import { Outlet, useLocation } from "react-router-dom";


export default function ApplicationsLayout() {

    const location = useLocation()

    const links: MenuProp[] = [
        // {
        //     label: "Residece", path: "/applications/investments",
        //     pattern: new RegExp("^/applications/investments$")
        // },
        {
            label: "Licence", path: "/applications/licences",
            pattern: new RegExp("^/applications/licences$")
        },

    ]

    return (
        <div className="w-full ">
            {
                location.pathname !== "/applications/investments/applications-details/:" && location.pathname !== "/applications/licences/applications-details/:" && (
                    <div className="px-5 mt-5">
                        <HorizontalMenu
                            links={links} />
                    </div>
                )
            }
            <Outlet />
        </div>
    )
}